import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController, AlertController, Platform, ToastController, ModalController } from '@ionic/angular';
import { ActionSheetButton, ActionSheetOptions, TextFieldTypes } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from '@app/i18n';
import { CredentialsService } from '@app/auth';
import { AuthService } from '@app/@shared/services/auth.service';
import { environment } from '@env/environment';
import { TrackingService } from '@app/@shared/services/tracking.service';
import { AnalyticsEventName } from '@app/@shared/models/tracking.model';
import { LoginModalComponent } from '@app/auth/login-modal.component';
import { BrandingService } from '@shared/services/branding.service';

import { Capacitor } from '@capacitor/core';
import { Timestamp } from 'firebase/firestore';
import { CustomerService } from '@app/@shared/services/customer.service';
declare global {
  interface Window {
    zE: any;
  }
}
@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent {
  isProd = false;
  sorteosHeader = [
    {
      name: 'Chispazo',
      logo: 'chispazo',
      shortName: 'Chispazo',
      message: '¡Juega desde $10.00 pesos!',
      amount: 500,
      path: ['/', 'game', 'chispazo'],
      date: '2024-10-30',
      showButtonBar: true,
    },
    {
      name: 'Melate revancha revanchita',
      logo: 'melaterevancha',
      shortName: 'Melate',
      message: 'Con una bolsa acumulada de',
      amount: 206000,
      path: ['/', 'game', 'melate'],
      date: '2024-10-30',
      showButtonBar: true,
    },
    {
      name: 'Melate Retro',
      logo: 'melateretro',
      shortName: 'M Retro',
      message: 'Con una bolsa acumulada de',
      amount: 206000,
      path: ['/', 'game', 'melate', 'retro'],
      date: '2024-10-30',
      showButtonBar: true,
    },
    {
      name: 'Tri$',
      logo: 'tris',
      shortName: 'Tris',
      message: 'Con una bolsa acumulada de',
      amount: 206000,
      path: ['/', 'game', 'tris'],
      date: '2024-10-30',
      showButtonBar: true,
    },
    {
      name: 'Gana Gato',
      logo: 'ganagato',
      shortName: 'Gana Gato',
      message: '¡Juega desde $10.00 pesos!',
      amount: 500,
      date: '2024-10-30',
      path: ['/', 'game', 'gana-gato'],
      showButtonBar: true,
    },
    {
      name: 'Progol',
      shortName: 'Progol',
      logo: 'progol',
      message: '¡Juega desde $10.00 pesos!',
      amount: 5000,
      date: '2024-10-30',
      path: ['/', 'game', 'progol'],
      showButtonBar: true,
    },
    {
      name: 'Progol Media Semana',
      shortName: 'Progol MS',
      logo: 'progolmedia',
      message: '¡Juega desde $10.00 pesos!',
      amount: 5000,
      date: '2024-10-30',
      path: ['/', 'game', 'progol', 'media-semana'],
      showButtonBar: false,
    },
    {
      name: 'Pronosports',
      shortName: 'Pronosports',
      logo: 'pronosports',
      message: '¡Juega desde $10.00 pesos!',
      amount: 5000,
      date: '2024-10-30',
      path: ['/', 'game', 'prono-sports'],
      showButtonBar: true,
    },
    {
      name: 'Protouch',
      shortName: 'Protouch',
      logo: 'protouch',
      message: '¡Juega desde $10.00 pesos!',
      amount: 5000,
      date: '2024-10-30',
      path: ['/', 'game', 'protouch'],
      showButtonBar: false,
    },
    {
      name: 'Sorteo Especial',
      shortName: 'S. Especial',
      logo: 'sorteoespecial',
      message: 'Con una bolsa acumulada de',
      amount: 10000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'especial'],
      showButtonBar: true,
    },
    {
      name: 'Sorteo Magno',
      shortName: 'S. Magno',
      logo: 'sorteomagno',
      message: 'Con una bolsa acumulada de',
      amount: 15000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'magno'],
      showButtonBar: true,
    },
    {
      name: 'Sorteo Mayor',
      shortName: 'S. Mayor',
      logo: 'sorteomayor',
      message: 'Con una bolsa acumulada de',
      amount: 20000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'mayor'],
      showButtonBar: true,
    },
    {
      name: 'Sorteo Superior',
      shortName: 'S. Superior',
      logo: 'sorteosuperior',
      message: 'Con una bolsa acumulada de',
      amount: 25000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'superior'],
      showButtonBar: true,
    },
    {
      name: 'Sorteo Zodiaco',
      shortName: 'S. Zodiaco',
      logo: 'sorteozodiaco',
      message: 'Con una bolsa acumulada de',
      amount: 30000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'zodiaco'],
      showButtonBar: true,
    },
    {
      name: 'Sorteo Zodiaco Especial',
      shortName: 'S. Zodiaco Esp.',
      logo: 'sorteozodiaco',
      message: 'Con una bolsa acumulada de',
      amount: 30000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'zodiaco-especial'],
      showButtonBar: true,
    },
    {
      name: 'Sorteo Gran Especial',
      shortName: 'S. G. Especial',
      logo: 'zodiacoespecial',
      message: 'Con una bolsa acumulada de',
      amount: 35000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'gran-especial'],
      showButtonBar: false,
    },
    {
      name: 'Sorteo Navidad',
      shortName: 'S. Navidad',
      logo: 'sorteozodiaco',
      message: 'Con una bolsa acumulada de',
      amount: 30000,
      date: '2024-10-30',
      path: ['/', 'game', 'sorteo', 'gordito'],
      showButtonBar: true,
    },
  ];
  gamesMenuShow = false;
  isAllowedCountry = localStorage.getItem('isAllowedCountry') === 'true';

  private modalOpen = false;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private platform: Platform,
    private alertController: AlertController,
    private actionSheetController: ActionSheetController,
    private authService: AuthService,
    private credentialsService: CredentialsService,
    private i18nService: I18nService,
    private toasCtrl: ToastController,
    private customerS: CustomerService,
    public trackingS: TrackingService,
    private modalCtrl: ModalController,
    public brandingService: BrandingService
  ) {
    this.isProd = environment.production;
  }

  async showProfileActions() {
    let createdActionSheet: any;
    const buttons: ActionSheetButton[] = [
      {
        text: this.translateService.instant('Logout'),
        icon: this.platform.is('ios') ? undefined : 'log-out',
        role: 'destructive',
        handler: () => this.logout(),
      },
      {
        text: this.translateService.instant('Change language'),
        icon: this.platform.is('ios') ? undefined : 'globe',
        handler: async () => {
          // Wait for action sheet dismiss animation to finish, see "Dismissing And Async Navigation" section in:
          // http://ionicframework.com/docs/api/components/action-sheet/ActionSheetController/#advanced
          await createdActionSheet.dismiss();
          this.changeLanguage();
          return false;
        },
      },
      {
        text: this.translateService.instant('Cancel'),
        icon: this.platform.is('ios') ? undefined : 'close',
        role: 'cancel',
      },
    ];

    // On Cordova platform language is set to the device language
    if (this.platform.is('cordova')) {
      buttons.splice(1, 1);
    }

    const actionSheetOptions: ActionSheetOptions = {
      header: this.username || undefined,
      buttons,
    };

    createdActionSheet = await this.actionSheetController.create(actionSheetOptions);
    await createdActionSheet.present();
  }

  get username(): string | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.name : null;
  }

  get email(): string | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.email : null;
  }

  get isAuthenticated(): boolean {
    return this.credentialsService.isAuthenticated();
  }

  /**
   * Maneja la navegación desde el menú, verificando autenticación excepto para rutas legales
   */
  async handleMenuNavigation(route: string, event?: Event): Promise<void> {
    // Si hay evento, prevenir comportamiento por defecto
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Permitir siempre acceso a rutas legales y home
    if (route.includes('/legal') || route === '/home' || route === '/') {
      this.router.navigate([route], { queryParamsHandling: 'preserve' });
      return;
    }

    // Si no está autenticado, mostrar modal de login
    if (!this.isAuthenticated) {
      if (!this.modalOpen) {
        this.modalOpen = true;

        const modal = await this.modalCtrl.create({
          component: LoginModalComponent,
          backdropDismiss: false,
          cssClass: 'login-modal',
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();
        this.modalOpen = false;

        // Si el login fue exitoso, navegar a la ruta
        if (data?.success && this.isAuthenticated) {
          this.router.navigate([route], { queryParamsHandling: 'preserve' });
        }
      }
    } else {
      // Si está autenticado, navegar normalmente
      this.router.navigate([route], { queryParamsHandling: 'preserve' });
    }
  }

  private async logout() {
    await this.authService.logOut();
    await this.router.navigate(['/home'], { replaceUrl: true, queryParamsHandling: 'preserve' });

    // Abrir modal de login automáticamente
    if (!this.modalOpen) {
      this.modalOpen = true;

      const modal = await this.modalCtrl.create({
        component: LoginModalComponent,
        backdropDismiss: false,
        cssClass: 'login-modal',
      });

      await modal.present();

      const { data } = await modal.onDidDismiss();
      this.modalOpen = false;

      // Si el login fue exitoso, el guard de autenticación manejará la navegación
      if (data?.success && this.isAuthenticated) {
        // El usuario puede navegar después del login
      }
    }
  }

  get isWeb(): boolean {
    return !this.platform.is('cordova');
  }
  // function that opens a link depending on the platform (ios, android or web
  async rateUs() {
    let destiny = '';
    // console.log('rateUs');
    this.platform;
    if (this.platform.is('ios')) {
      destiny = 'ios';
      //console.log('ios');
      const url = 'https://apps.apple.com/mx/app/cm-pron%C3%B3sticos-y-loter%C3%ADa/id1282052669';
      window.open(url, '_system');
    } else if (this.platform.is('android')) {
      destiny = 'android';
      //  console.log('android');
      const url = 'https://apps.apple.com/mx/app/cm-pron%C3%B3sticos-y-loter%C3%ADa/id1282052669';
      window.open(url, '_system');
    } else {
      destiny = 'desktop';
      //  console.log('desktop');
      const url = 'https://www.facebook.com/cmillonario';
      window.open(url, '_blank');
    }
    this.trackingPageInfo('page_visited', 'Rate us');
  }

  private async changeLanguage() {
    const alertController = await this.alertController.create({
      header: this.translateService.instant('Change language'),
      inputs: this.i18nService.supportedLanguages.map((language) => ({
        type: 'radio' as TextFieldTypes,
        name: language,
        label: language,
        value: language,
        checked: language === this.i18nService.language,
      })),
      buttons: [
        {
          text: this.translateService.instant('Cancel'),
          role: 'cancel',
        },
        {
          text: this.translateService.instant('Ok'),
          handler: (language) => {
            this.i18nService.language = language;
          },
        },
      ],
    });
    await alertController.present();
  }
  async openAddFundsModal() {
    if (this.credentialsService.credentials?.customer?.exclusion) {
      const customer = this.credentialsService.credentials.customer;
      const timeEx = customer.timeEx;
      const periodEx = customer.periodEx as Timestamp; // Firestore Timestamp

      let formattedDate = '';

      // Convierte el Timestamp a Date
      const dateObj = periodEx.toDate();
      const today = new Date(); // Fecha actual
      // Formatear la fecha como "día de mes de año"
      formattedDate = dateObj.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

      if (today < dateObj) {
        // Mensaje dinámico según timeEx
        let message = '';
        if (timeEx === '0') {
          message =
            'Tu cuenta está actualmente en autoexclusión y no puedes cargar saldo por tiempo indefinido. Si quieres reactivar tu acceso contacta a atencion_clientes@cmillonario.mx.';
        } else {
          message = `Tu cuenta está actualmente en autoexclusión y no puedes cargar saldo por ${timeEx} meses, hasta el día ${formattedDate}.`;
        }

        const alert = await this.alertController.create({
          header: 'Autoexclusión activa',
          message,
          buttons: [
            {
              text: 'Aceptar',
              role: 'cancel',
            },
          ],
          cssClass: 'alert',
        });

        await alert.present();
      } else {
        const platform = Capacitor.getPlatform();
        await this.customerS.update(this.credentialsService.credentials?.id as string, { exclusion: false });
        this.credentialsService.credentials!.customer.exclusion = false;
        const id = 'openFunds';
        document.getElementById(id)?.click();
      }
    } else {
      const platform = Capacitor.getPlatform();
      const id = 'openFunds';
      document.getElementById(id)?.click();
    }
    //this.cassino.loginCustomer({ username: 'demo', password: 'demo' }).subscribe({});
  }

  openLink(url: string): void {
    window.open(url, '_blank'); // Abre el enlace en una nueva pestaña.
  }
  async copyToken() {
    try {
      await navigator.clipboard.writeText(this.credentialsService.credentials!.token);
      // console.log('Texto copiado al portapapeles');
      const toast = await this.toasCtrl.create({
        message: 'Texto copiado al portapapeles',
        duration: 3000,
        buttons: [{ icon: 'close' }],
      });

      toast.present();
    } catch (err) {
      console.error('Error al copiar al portapapeles:', err);
    }
  }

  trackingPageInfo(event: AnalyticsEventName, page: string) {
    this.trackingS.trackEvent(
      event,
      {
        page_id: page,
      },
      false,
      false
    );
  }

  openZendesk(): void {
    if (window.zE) {
      window.zE('webWidget', 'open');
    } else {
      setTimeout(() => window.zE && window.zE('webWidget', 'open'), 500);
    }
  }
}
